import { Dropdown } from '@evolve/common-ui';
import React from 'react';
import { useLayoutContext } from '../../contexts';
import { cn } from '../../utils';

const navigateToTabUrl = (url: string) => {
  if (typeof window !== 'undefined') {
    window.location.assign(url);
  }
};

export default function Tabs({
  className,
  useDesktopTabs = false,
}: {
  className?: string;
  useDesktopTabs?: boolean;
}) {
  const context = useLayoutContext();
  let tabs = context.tabs;
  const tabsElements = tabs?.elements;
  const currentTab = tabs?.current;

  if (!tabsElements || tabsElements.length === 0) {
    return null;
  }

  return (
    <div className={cn('-mb-2 pt-4', className)}>
      <div className={cn('w-full sm:hidden', { hidden: useDesktopTabs })}>
        <Dropdown
          options={tabsElements.map((tab) => {
            return { label: tab.label, value: tab.key, url: tab.url };
          })}
          defaultValue={
            currentTab
              ? {
                  label:
                    tabsElements.find((tab) => tab.key === currentTab)?.label ??
                    '',
                  value: currentTab,
                }
              : undefined
          }
          label=""
          onChangeSelected={(option) => {
            if (option && tabs) {
              if (option.url) {
                navigateToTabUrl(option.url);
              } else {
                tabs.setCurrent(option.value);
              }
            }
          }}
        />
      </div>
      <div
        className={cn('', {
          'hidden sm:block': !useDesktopTabs,
        })}
      >
        <div className="border-b border-gray-200">
          <nav
            className="-mb-px flex flex-wrap gap-x-6 space-y-0"
            aria-label="Tabs"
          >
            {tabsElements.map((tab) => (
              <a
                key={tab.key}
                onClick={(event) => {
                  event.preventDefault();
                  if (tab.url) {
                    navigateToTabUrl(tab.url);
                  } else {
                    tabs?.setCurrent(tab.key);
                  }
                }}
                className={cn('border-b-2 px-1 py-2 text-sm', {
                  'border-evolve-primary text-evolve-primary font-medium':
                    tab.key === currentTab,
                  'cursor-pointer border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700':
                    tab.key !== currentTab,
                })}
                aria-current={tab.key === currentTab ? 'page' : undefined}
                href={tab.url ?? `#${tab.key}`}
              >
                {tab.label}
              </a>
            ))}
          </nav>
        </div>
      </div>
    </div>
  );
}
